import { Axios, AxiosError, AxiosResponse } from 'axios'
import { RemoteConfig } from './remote.config'

export class RegisterData {
	name: string;
	email: string;
	phone: string;
	password: string;

	constructor(name: string, email: string, phone: string, password: string) {
		this.name = name;
		this.email = email;
		this.phone = phone;
		this.password = password;
	}
}

export type RegisterAccountCallback = (resp?: AxiosResponse, err?: AxiosError) => void;

export const registerAccount = (data: RegisterData, callback: RegisterAccountCallback) => {
	const client = new Axios();
	const url = new URL("/api/v0/auth/register", RemoteConfig.url);
	const result = client.post(url.toString(), JSON.stringify(data), {headers: {
		'Content-Type': 'application/json'
	  }}).then((resp) => {
		callback(resp)
	})
}
